import { render, staticRenderFns } from "./SurplusesDataTable.vue?vue&type=template&id=c9bf98fa"
import script from "./SurplusesDataTable.vue?vue&type=script&lang=js"
export * from "./SurplusesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports